import { datastreamQueryKeys } from '@/common/query-keys';

export const notificationsQueryKeys = {
  base: [...datastreamQueryKeys.base, 'notifications'] as const,
  list: () => {
    return [...notificationsQueryKeys.base, 'list'] as const;
  },
};
